import styled from "styled-components"
import { device } from "breakpoints"

import { getSolidColor } from "../../utils/helpers/getSolidColor"
import { getGradient } from "../../utils/helpers/getGradient"

export const PaginationContainer = styled.div`
  display: flex;
  opacity: ${props => (props.noResults ? "0" : "1")};
  transition: 140ms;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 50px;
  padding-top: 30px;
  border-top: 1px solid #d2d4e0;
  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 120px;
  }
`
export const PageNumberList = styled.ul`
  list-style: none;
  display: flex;
  margin: 0 15px;
`

export const ListItem = styled.li`
  display: ${props => (props.hidden ? "none" : "block")};
  padding: 8px 7px;
  position: relative;

  @media ${device.desktop} {
    padding: 8px 6px;
  }
`

export const Number = styled.button`
  /* outline: none; */
  font-size: 19px;
  cursor: pointer;
  font-family: "Roboto", Arial, sans-serif;
  position: relative;
  padding: 0;
  color: black;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => (props.active ? props.theme.site : "none")};
  border: none;
  border-radius: 50%;
  transition: 80ms;
  font-weight: 500;
  line-height: 100% !important;
  font-weight: 700;
  :hover {
    :before {
      opacity: 0.5;
    }
  }
  :before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    height: 42px;
    width: 42px;
    border-radius: 50%;
    background: ${props => getGradient(props.theme.site)};
    z-index: 1;
    opacity: ${props => (props.active ? `1 !important` : 0)};
    transition: 90ms;
  }

  :after {
    content: "";
    position: absolute;
    top: 50%;
    height: 38px;
    width: 38px;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    border-radius: 50%;
    background: white;
    z-index: 2;
    opacity: 1;
  }

  span {
    z-index: 3;
    margin-top: -1px;
  }
`

export const Skip = styled(Number)`
  height: auto;
  width: auto;
`

export const NextButton = styled.button`
  display: inline-flex;
  border-radius: 2px;
  font-weight: 600;
  /* outline: none; */
  border: none;
  font-size: 16px;
  padding: 0 18px;
  height: 48px;
  width: 73px;
  color: white;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
  pointer-events: ${props => props.disabled && "none"};
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  background: ${props => getGradient(props.theme.site)};
  border-radius: 24.5px;

  :hover {
    transition: 90ms;
    opacity: 0.8;
  }

  @media ${device.desktop} {
    width: 91px;
    font-size: 20px;
  }
`

export const PreviousButton = styled(NextButton)``
export const ButtonsNumber = styled.div`
  display: ${props => (props.hide ? "none" : "flex")};
  flex-direction: row;
  margin: 0 auto;

  @media ${device.desktop} {
    width: 50%;
    margin: 0;
    justify-content: flex-end;
  }
`
export const PaginationResultsFound = styled.div`
  width: 100%;
  margin-bottom: 22px;
  span {
    font-weight: 600;
    color: black;
  }

  @media ${device.desktop} {
    width: 50%;
    margin-bottom: 0;

    font-size: 20px;
    letter-spacing: -0.16px;
    line-height: 30px;
  }
`
